module.exports = __webpack_public_path__ + "static/media/guide_step5.7ec48aa8.png";